<template>
  <div class="check-choice">
    <div class="check-head" v-if="appVersion === 'dd'">
      <div class="icon" @click="() => this.$router.back()">
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <h3 class="title">选择组织</h3>
    </div>
    <div class="input">
      <input v-model="search" type="text" placeholder="请输入名称搜索" placeholder-style="color:#C0C4CC" />
      <div class="search-box">
        <img @click="searchFun" src="../../assets/image/content_icon_search2x.png" />
      </div>
    </div>
    <div v-for="(item, Index) in list" :key="Index" style="margin-bottom: 25px">
      <div class="dd-box" @click="childFun(1, Index)">
        <div class="box-left">
          <img class="logo" :src="item.iconUrl" />
          <div :class="item.act ? 'text act' : 'text'">{{ item.displayName }}</div>
        </div>
        <img v-if="item.next" class="right" src="../../assets/image/content_icon_dropdown2x.png" />
      </div>
      <template v-if="item.show">
        <div v-for="(item1, index) in item.nextList" :key="index">
          <div class="dd-box" style="padding-left: 60px" @click="childFun(2, Index, index)">
            <div class="box-left">
              <img class="logo" :src="item1.iconUrl" />
              <div :class="item1.act ? 'text act' : 'text'">{{ item1.displayName }}</div>
            </div>
            <img v-if="item1.next" class="right" src="../../assets/image/content_icon_dropdown2x.png" />
          </div>
          <template v-if="item1.show">
            <div v-for="(item2, I) in item1.nextList" :key="I">
              <div class="dd-box" style="padding-left: 90px" @click="childFun(3, Index, index, I)">
                <div class="box-left">
                  <img class="logo" :src="item2.iconUrl" />
                  <div :class="item2.act ? 'text act' : 'text'">{{ item2.displayName }}</div>
                </div>
                <img v-if="item2.next" class="right" src="../../assets/image/content_icon_dropdown2x.png" />
              </div>
              <template v-if="item2.show">
                <div v-for="(item3, i) in item2.nextList" :key="i">
                  <div class="dd-box" style="padding-left: 120px" @click="childFun(4, Index, index, I, i)">
                    <div class="box-left">
                      <img class="logo" :src="item3.iconUrl" />
                      <div :class="item3.act ? 'text act' : 'text'">{{ item3.displayName }}</div>
                    </div>
                    <img v-if="item3.next" class="right" src="../../assets/image/content_icon_dropdown2x.png" />
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div style="width: 100%; height: 95px"></div>
    <div :class="act ? 'sure yes' : 'sure'" @click="next">下一步</div>
  </div>
</template>

<script>
import {baseURL} from '@/api/request'
import Axios from 'axios'
const unitAttr1 = require('../../assets/image/type1.png')
const unitAttr2 = require('../../assets/image/type2.png')
export default {
  name: 'registerChoice',
  data() {
    return {
      phone: '',
      type: '',
      search: '',
      pageIndex: 1,
      list: [],
      parentId: 0,
      act: false, // 选中的机构
      verifyId: ''
    }
  },
  methods: {
    unitAttrIcon(unitAttr) {
      unitAttr = Number(unitAttr)
      if (unitAttr === 1 || unitAttr === 2 || unitAttr === 4) {
        return unitAttr1
      } else if (unitAttr === 8 || unitAttr === 16 || unitAttr === 32 || unitAttr === 64 || unitAttr === 129) {
        return unitAttr2
      }
      return unitAttr1
    },
    handleMapOrgData(data) {
      const list = data.map(item => {
        item.iconUrl = this.unitAttrIcon(item.unitAttr)
        if (item.next) {
          item.nextList = []
          item.show = false
          item.act = false
        }
        return item
      })
      return list
    },
    searchFun() {
      this.act = false
      Axios.post(baseURL + '/base-api/base/api/organizationUnit/findOrgByName', {
        displayName: this.search,
        pageIndex: this.pageIndex,
        pageSize: 20,
        status: 0
      }).then(res => {
        if (res.data.code === 0) {
          const data = res.data.data
          this.list = this.handleMapOrgData(data)
        } else {
          this.GetUnitAll()
        }
      })
    },
    next() {
      if (!this.act) {
        this.$Toast.fail('请选择机构')
      } else {
        const obj = {
          displayName: this.act.displayName,
          id: this.act.id
        }
        sessionStorage.setItem('choice', JSON.stringify(obj))
        this.$router.back()
      }
    },
    childFun(type, Index, index, I, i) {
      // let parentId = 0
      switch (type) {
        case 1: {
          if (this.list[Index].next) {
            if (this.list[Index].nextList.length === 0) {
              this.parentId = this.list[Index].id
              this.GetChild(type, Index)
            } else {
              this.list[Index].show = !this.list[Index].show
            }
          } else {
          }
          this.forEachFun(Index, -1, -1, -1)
          break
        }
        case 2: {
          if (this.list[Index].nextList[index].next) {
            if (this.list[Index].nextList[index].nextList.length === 0) {
              this.parentId = this.list[Index].nextList[index].id
              this.GetChild(type, Index, index)
            } else {
              this.list[Index].nextList[index].show = !this.list[Index].nextList[index].show
            }
          } else {
          }
          this.forEachFun(Index, index, -1, -1)
          break
        }
        case 3: {
          if (this.list[Index].nextList[index].nextList[I].next) {
            if (this.list[Index].nextList[index].nextList[I].nextList.length === 0) {
              this.parentId = this.list[Index].nextList[index].nextList[I].id
              this.GetChild(type, Index, index, I)
            } else {
              this.list[Index].nextList[index].nextList[I].show = !this.list[Index].nextList[index].nextList[I].show
            }
          } else {
          }
          this.forEachFun(Index, index, I, -1)
          break
        }
      }
      if (type === 4) {
        this.forEachFun(Index, index, I, i)
      }
    },
    GetChild(type, Index, index, I, i) {
      Axios.get(baseURL + '/base-api/base/api/organizationUnit/all', {
        params: {
          level: 1,
          onlyOrg: 0,
          parentId: this.parentId,
          status: 0
        }
      }).then(res => {
        const data = res.data.data
        if (type === 1) {
          this.list[Index].nextList = this.handleMapOrgData(data)
          this.list[Index].show = true
        }
        if (type === 2) {
          this.list[Index].nextList[index].nextList = this.handleMapOrgData(data)
          this.list[Index].nextList[index].show = true
        }
        if (type === 3) {
          this.list[Index].nextList[index].nextList[I].nextList = this.handleMapOrgData(data)
          this.list[Index].nextList[index].nextList[I].show = true
        }
      })
    },
    forEachFun(Index, index, I, i) {
      let type = 0
      if (i === -1) {
        type = 3
      }
      if (I === -1) {
        type = 2
      }
      if (index === -1) {
        type = 1
      }
      if (index !== -1 && I !== -1 && i !== -1) {
        type = 4
      }
      const lists = this.list.concat([])
      lists.forEach((item, Index0) => {
        if (Index0 === Index) {
          item.act = true
        } else {
          item.act = false
        }
        if (type === 1 && Index0 === Index) {
          this.act = item
        }
        item.nextList &&
          item.nextList.forEach((item1, Index1) => {
            if (Index1 === index) {
              item1.act = true
            } else {
              item1.act = false
            }
            if (type === 2 && Index1 === index) {
              this.act = item1
            }
            item1.nextList &&
              item1.nextList.forEach((item2, Index2) => {
                if (Index2 === I) {
                  item2.act = true
                } else {
                  item2.act = false
                }
                if (type === 3 && Index2 === I) {
                  this.act = item2
                }
                item2.nextList &&
                  item2.nextList.forEach((item3, Index3) => {
                    if (Index3 === i) {
                      item3.act = true
                    } else {
                      item3.act = false
                    }
                    if (type === 4 && Index3 === i) {
                      this.act = item3
                    }
                  })
              })
          })
      })
      this.list = lists
    },
    GetUnitAll() {
      Axios.get(baseURL + '/base-api/base/api/organizationUnit/all', {
        params: {
          level: 1,
          onlyOrg: 0,
          parentId: 0,
          status: 0
        }
      }).then(res => {
        const data = res.data.data
        this.list = this.handleMapOrgData(data)
      })
    }
  },
  created() {
    this.phone = this.$route.query.phone
    this.type = this.$route.query.type
    this.verifyId = this.$route.query.verifyId
    console.log('baseURL', baseURL)
    Axios.get(baseURL + '/base-api/base/api/organizationUnit/all', {
      params: {
        level: 1,
        onlyOrg: 0,
        parentId: 0,
        status: 0
      }
    }).then(res => {
      const data = res.data.data
      this.list = this.handleMapOrgData(data)
    })
  }
}
</script>

<style lang="scss" scoped>
.check-choice {
  width: 100%;
  min-height: 100vh;
  background: #fff;
}
.check-choice > p {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  color: rgba(144, 147, 153, 1);
  font-size: 14px;
}

.check-choice .check-head {
  position: relative;
  width: 100%;
  height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #fff;
  .icon {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 100%;
    i {
      display: inline-block;
      font-size: 20px;
      font-weight: 700;
      transform: rotate(180deg);
    }
  }
  .title {
    line-height: 50px;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
  }
}

.input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 36px;
  border-radius: 18px;
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  padding: 0 0 0 15px;
  box-sizing: border-box;
  background: rgba(244, 246, 249, 1);

  input {
    width: 90%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    background: rgba(244, 246, 249, 1);
    outline: none;
    border: none;
    float: left;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 13%;
    height: 100%;
    img {
    }
  }

  img {
    width: 15px;
    height: 15px;
    float: right;
  }
}

.dd-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 72.5px;
  padding: 12.5px 15px;
  box-sizing: border-box;
  color: rgba(48, 49, 51, 1);
  .box-left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .logo {
    width: 47.5px;
    height: 47.5px;
  }

  .text {
    height: 100%;
    margin-left: 12.5px;

    font-size: 15px;
    line-height: 15px;
  }

  .act {
    color: #4a86f6;
  }

  .right {
    width: 10px;
    height: 6px;
  }
}

.sure {
  width: 100%;
  height: 47px;
  line-height: 47px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  position: fixed;
  bottom: 0;
  background: linear-gradient(to right, #bdd1f8, #bbc8f7);
}

.yes {
  background: linear-gradient(to right, #4a86f6, #4465f3);
}
</style>
